/**
 * AdminDashboard - Landing page for admin functionality
 *
 * Displays navigation cards for User Management and Metrics sections.
 */

import React from "react";
import { useNavigate } from "react-router-dom";
import { PeopleRegular, DataTrendingRegular, HistoryRegular } from "@fluentui/react-icons";
import { AppHeader } from "@shared/components";
import styles from "./AdminDashboard.module.css";

interface DashboardCard {
  title: string;
  description: string;
  icon: React.ReactNode;
  path: string;
}

const cards: DashboardCard[] = [
  {
    title: "User Management",
    description: "Create, edit, and manage user accounts and roles",
    icon: <PeopleRegular />,
    path: "/admin/users",
  },
  {
    title: "Feedback Metrics",
    description: "View failure statistics and system insights",
    icon: <DataTrendingRegular />,
    path: "/admin/failure-stats",
  },
  {
    title: "Query Logs",
    description: "View user queries and LLM responses",
    icon: <HistoryRegular />,
    path: "/admin/query-logs",
  },
];

export const AdminDashboard: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className={styles.container}>
      <AppHeader currentApp="admin" />
      <main className={styles.main}>
        <h1 className={styles.title}>Admin Dashboard</h1>
        <div className={styles.cardGrid}>
          {cards.map((card) => (
            <button
              key={card.path}
              className={styles.card}
              onClick={() => navigate(card.path)}
            >
              <div className={styles.cardIcon}>{card.icon}</div>
              <h2 className={styles.cardTitle}>{card.title}</h2>
              <p className={styles.cardDescription}>{card.description}</p>
            </button>
          ))}
        </div>
      </main>
    </div>
  );
};
